// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MDM uses Quill's flat lists and ql-indent-* classes.
   Keep these read-only styles scoped to the saved legal content. */
.kmZ_lKFvUkaVFoLk6uKq {
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  -moz-tab-size: 4;
    -o-tab-size: 4;
       tab-size: 4;
  counter-reset: terms-level-0 terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5
    terms-level-6 terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq img {
  max-width: 100%;
  height: auto;
}

/* Quill restarts indented numbering at each new text/list block. */
.kmZ_lKFvUkaVFoLk6uKq p,
.kmZ_lKFvUkaVFoLk6uKq ol,
.kmZ_lKFvUkaVFoLk6uKq ul,
.kmZ_lKFvUkaVFoLk6uKq pre,
.kmZ_lKFvUkaVFoLk6uKq blockquote,
.kmZ_lKFvUkaVFoLk6uKq h1,
.kmZ_lKFvUkaVFoLk6uKq h2,
.kmZ_lKFvUkaVFoLk6uKq h3,
.kmZ_lKFvUkaVFoLk6uKq h4,
.kmZ_lKFvUkaVFoLk6uKq h5,
.kmZ_lKFvUkaVFoLk6uKq h6 {
  counter-set: terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5 terms-level-6
    terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol,
.kmZ_lKFvUkaVFoLk6uKq ul {
  margin: 0 0 0.75em;
  padding-left: 1.75em;
  list-style-position: outside;
}

.kmZ_lKFvUkaVFoLk6uKq ol {
  list-style-type: decimal;
  /* Separate lists restart at 1, as they do in the MDM editor. */
  counter-reset: terms-level-0;
}

.kmZ_lKFvUkaVFoLk6uKq ul {
  list-style-type: disc;
}

.kmZ_lKFvUkaVFoLk6uKq li {
  margin-bottom: 0.5em;
  padding-left: 0;
  text-indent: 0;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li {
  counter-increment: terms-level-0;
  counter-set: terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5 terms-level-6
    terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li::marker {
  content: counter(terms-level-0, decimal) ". ";
}

/* Also support ordinary nested HTML lists, not just Quill's flat markup. */
.kmZ_lKFvUkaVFoLk6uKq ol ol {
  counter-reset: terms-level-0 terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5
    terms-level-6 terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-1 {
  margin-left: 3em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-1 {
  counter-increment: terms-level-1;
  counter-set: terms-level-2 terms-level-3 terms-level-4 terms-level-5 terms-level-6 terms-level-7
    terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-1::marker {
  content: counter(terms-level-1, lower-alpha) ". ";
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-2 {
  margin-left: 6em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-2 {
  counter-increment: terms-level-2;
  counter-set: terms-level-3 terms-level-4 terms-level-5 terms-level-6 terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-2::marker {
  content: counter(terms-level-2, lower-roman) ". ";
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-3 {
  margin-left: 9em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-3 {
  counter-increment: terms-level-3;
  counter-set: terms-level-4 terms-level-5 terms-level-6 terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-3::marker {
  content: counter(terms-level-3, decimal) ". ";
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-4 {
  margin-left: 12em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-4 {
  counter-increment: terms-level-4;
  counter-set: terms-level-5 terms-level-6 terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-4::marker {
  content: counter(terms-level-4, lower-alpha) ". ";
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-5 {
  margin-left: 15em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-5 {
  counter-increment: terms-level-5;
  counter-set: terms-level-6 terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-5::marker {
  content: counter(terms-level-5, lower-roman) ". ";
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-6 {
  margin-left: 18em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-6 {
  counter-increment: terms-level-6;
  counter-set: terms-level-7 terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-6::marker {
  content: counter(terms-level-6, decimal) ". ";
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-7 {
  margin-left: 21em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-7 {
  counter-increment: terms-level-7;
  counter-set: terms-level-8;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-7::marker {
  content: counter(terms-level-7, lower-alpha) ". ";
}

.kmZ_lKFvUkaVFoLk6uKq .ql-indent-8 {
  margin-left: 24em;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-8 {
  counter-increment: terms-level-8;
  counter-set: none;
}

.kmZ_lKFvUkaVFoLk6uKq ol > li.ql-indent-8::marker {
  content: counter(terms-level-8, lower-roman) ". ";
}
`, "",{"version":3,"sources":["webpack://./src/components/common/LegalContent/LegalContent.module.css"],"names":[],"mappings":"AAAA;mEACmE;AACnE;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gBAAW;IAAX,cAAW;OAAX,WAAW;EACX;6CAC2C;AAC7C;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,mEAAmE;AACnE;;;;;;;;;;;EAWE;+BAC6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,+DAA+D;EAC/D,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC;+BAC6B;AAC/B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,2EAA2E;AAC3E;EACE;6CAC2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC;iBACe;AACjB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gGAAgG;AAClG;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,kFAAkF;AACpF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,oEAAoE;AACtE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;AACxD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":["/* MDM uses Quill's flat lists and ql-indent-* classes.\n   Keep these read-only styles scoped to the saved legal content. */\n.content {\n  overflow-wrap: anywhere;\n  white-space: pre-wrap;\n  tab-size: 4;\n  counter-reset: terms-level-0 terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5\n    terms-level-6 terms-level-7 terms-level-8;\n}\n\n.content img {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Quill restarts indented numbering at each new text/list block. */\n.content p,\n.content ol,\n.content ul,\n.content pre,\n.content blockquote,\n.content h1,\n.content h2,\n.content h3,\n.content h4,\n.content h5,\n.content h6 {\n  counter-set: terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5 terms-level-6\n    terms-level-7 terms-level-8;\n}\n\n.content ol,\n.content ul {\n  margin: 0 0 0.75em;\n  padding-left: 1.75em;\n  list-style-position: outside;\n}\n\n.content ol {\n  list-style-type: decimal;\n  /* Separate lists restart at 1, as they do in the MDM editor. */\n  counter-reset: terms-level-0;\n}\n\n.content ul {\n  list-style-type: disc;\n}\n\n.content li {\n  margin-bottom: 0.5em;\n  padding-left: 0;\n  text-indent: 0;\n}\n\n.content ol > li {\n  counter-increment: terms-level-0;\n  counter-set: terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5 terms-level-6\n    terms-level-7 terms-level-8;\n}\n\n.content ol > li::marker {\n  content: counter(terms-level-0, decimal) \". \";\n}\n\n/* Also support ordinary nested HTML lists, not just Quill's flat markup. */\n.content ol ol {\n  counter-reset: terms-level-0 terms-level-1 terms-level-2 terms-level-3 terms-level-4 terms-level-5\n    terms-level-6 terms-level-7 terms-level-8;\n}\n\n.content :global(.ql-indent-1) {\n  margin-left: 3em;\n}\n\n.content ol > li:global(.ql-indent-1) {\n  counter-increment: terms-level-1;\n  counter-set: terms-level-2 terms-level-3 terms-level-4 terms-level-5 terms-level-6 terms-level-7\n    terms-level-8;\n}\n\n.content ol > li:global(.ql-indent-1)::marker {\n  content: counter(terms-level-1, lower-alpha) \". \";\n}\n\n.content :global(.ql-indent-2) {\n  margin-left: 6em;\n}\n\n.content ol > li:global(.ql-indent-2) {\n  counter-increment: terms-level-2;\n  counter-set: terms-level-3 terms-level-4 terms-level-5 terms-level-6 terms-level-7 terms-level-8;\n}\n\n.content ol > li:global(.ql-indent-2)::marker {\n  content: counter(terms-level-2, lower-roman) \". \";\n}\n\n.content :global(.ql-indent-3) {\n  margin-left: 9em;\n}\n\n.content ol > li:global(.ql-indent-3) {\n  counter-increment: terms-level-3;\n  counter-set: terms-level-4 terms-level-5 terms-level-6 terms-level-7 terms-level-8;\n}\n\n.content ol > li:global(.ql-indent-3)::marker {\n  content: counter(terms-level-3, decimal) \". \";\n}\n\n.content :global(.ql-indent-4) {\n  margin-left: 12em;\n}\n\n.content ol > li:global(.ql-indent-4) {\n  counter-increment: terms-level-4;\n  counter-set: terms-level-5 terms-level-6 terms-level-7 terms-level-8;\n}\n\n.content ol > li:global(.ql-indent-4)::marker {\n  content: counter(terms-level-4, lower-alpha) \". \";\n}\n\n.content :global(.ql-indent-5) {\n  margin-left: 15em;\n}\n\n.content ol > li:global(.ql-indent-5) {\n  counter-increment: terms-level-5;\n  counter-set: terms-level-6 terms-level-7 terms-level-8;\n}\n\n.content ol > li:global(.ql-indent-5)::marker {\n  content: counter(terms-level-5, lower-roman) \". \";\n}\n\n.content :global(.ql-indent-6) {\n  margin-left: 18em;\n}\n\n.content ol > li:global(.ql-indent-6) {\n  counter-increment: terms-level-6;\n  counter-set: terms-level-7 terms-level-8;\n}\n\n.content ol > li:global(.ql-indent-6)::marker {\n  content: counter(terms-level-6, decimal) \". \";\n}\n\n.content :global(.ql-indent-7) {\n  margin-left: 21em;\n}\n\n.content ol > li:global(.ql-indent-7) {\n  counter-increment: terms-level-7;\n  counter-set: terms-level-8;\n}\n\n.content ol > li:global(.ql-indent-7)::marker {\n  content: counter(terms-level-7, lower-alpha) \". \";\n}\n\n.content :global(.ql-indent-8) {\n  margin-left: 24em;\n}\n\n.content ol > li:global(.ql-indent-8) {\n  counter-increment: terms-level-8;\n  counter-set: none;\n}\n\n.content ol > li:global(.ql-indent-8)::marker {\n  content: counter(terms-level-8, lower-roman) \". \";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `kmZ_lKFvUkaVFoLk6uKq`
};
export default ___CSS_LOADER_EXPORT___;
